import Line from "../components/chart/Line";

function ItemCard({ icon, name, symbol, bal, balusd, currency = "$" }) {
    return (
      <div className="col-xxl-4 col-md-6 col-12 g-4">
        <div className="glozzy rounded-3 p-2">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="rounded-3 d-flex align-items-center justify-content-center shadow-lg bg-black" style={{width:'45px', height:'45px'}}>
                {icon}
              </div>
              <div className="ms-2">
                <h6 className="mb-0 fw-bold text-white" style={{fontSize: '17px'}}>{name}</h6>
                <p className="mb-0 fw-bold text-secondary" style={{fontSize: '14px'}}>{symbol}</p>
              </div>
            </div>
            <div className="text-end">
              <h6 className="mb-0 fw-bold text-prime" style={{fontSize: '17px'}}>{(currency)?currency:'$'}{balusd}</h6>
              <p className="mb-0 fw-bold text-secondary" style={{fontSize: '14px'}}>{bal} {symbol}</p>
            </div>
          </div>
          <Line/>
        </div>
      </div>
    )
  }
  
  export default ItemCard